import React from 'react';
function ElmoSort() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M7 20V7.99H4L8 4L12 7.99H9V20H7ZM17 4V16.01H20L16 20L12 16.01H15V4H17Z" })));
}
export default ElmoSort;
